if (!customElements.get('pop-menu')) {
  customElements.define(
    'pop-menu',
    class PopMenu extends HTMLElement {
      constructor() {
        super();
        this.isInitialized = false;
      }

      connectedCallback() {
        if (this.isInitialized) return;
        this.elements = {
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          disclosure: this.querySelector('.disclosure'),
        };

        // popover="auto": native light-dismiss/Escape; closeSelector still covers keyboard Tab-away.
        const { button, panel } = this.elements;
        panel.removeAttribute('hidden');
        panel.setAttribute('popover', 'auto');
        panel.addEventListener('toggle', this.onToggle.bind(this));

        this.onReposition = this.positionPanel.bind(this);

        button.addEventListener('click', this.openSelector.bind(this));
        button.addEventListener('focusout', this.closeSelector.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.isInitialized = true;
      }

      // Manual positioning instead of CSS Anchor Positioning — cross-browser support was too
      // limited at the time this was written. Revisit migrating to it later.
      positionPanel() {
        const { panel, disclosure, button } = this.elements;
        const containerRect = (disclosure || button).getBoundingClientRect();
        const isPopDown100vw = this.querySelector('.disclosure--pop-down-100vw');
        const isPopDown = this.querySelector('.disclosure--pop-down');

        panel.style.top = 'auto';
        panel.style.bottom = 'auto';
        panel.style.left = 'auto';
        panel.style.right = 'auto';
        panel.style.transform = '';

        if (isPopDown100vw) {
          panel.style.top = `${containerRect.bottom}px`;
          panel.style.left = '50%';
          panel.style.transform = 'translateX(-50%)';
        } else if (isPopDown) {
          panel.style.top = `${containerRect.bottom}px`;
          panel.style.right = `${document.documentElement.clientWidth - containerRect.right}px`;
        } else {
          panel.style.bottom = `${window.innerHeight - containerRect.top}px`;
          panel.style.left = `${containerRect.left}px`;
        }
      }

      hide() {
        if (this.elements.panel.matches(':popover-open')) {
          this.elements.panel.hidePopover();
        }
      }

      onToggle(event) {
        const isOpen = event.newState === 'open';
        this.elements.button.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          window.addEventListener('scroll', this.onReposition, true);
        } else {
          window.removeEventListener('scroll', this.onReposition, true);
        }
      }

      onItemClick(event) {}

      openSelector(event) {
        this.elements.button.focus();
        if (this.elements.panel.matches(':popover-open')) {
          this.hide();
          return;
        }
        this.positionPanel();
        this.elements.panel.showPopover();
      }

      closeSelector(event) {
        // event.target here is always the button itself; check relatedTarget (where focus is going).
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);

        if (!isChild) {
          this.hide();
        }
      }
    }
  );
}
